import { render, staticRenderFns } from "./UserPermissionsBrowseRow.vue?vue&type=template&id=e29e0f22&scoped=true"
import script from "./UserPermissionsBrowseRow.vue?vue&type=script&lang=ts"
export * from "./UserPermissionsBrowseRow.vue?vue&type=script&lang=ts"
import style0 from "./UserPermissionsBrowseRow.vue?vue&type=style&index=0&id=e29e0f22&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e29e0f22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e29e0f22')) {
      api.createRecord('e29e0f22', component.options)
    } else {
      api.reload('e29e0f22', component.options)
    }
    module.hot.accept("./UserPermissionsBrowseRow.vue?vue&type=template&id=e29e0f22&scoped=true", function () {
      api.rerender('e29e0f22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/UserPermissionsBrowseRow.vue"
export default component.exports